/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from '../../services/auth.service'

export interface DeactivationGuarded {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<any> {
  private readonly authService = inject(AuthService)

  canDeactivate(component: DeactivationGuarded): boolean | Observable<boolean> | Promise<boolean> {
    // The session is over (logout, expired token, idle timeout)
    if (this.authService.isLoggingOut) {
      return true
    }

    return component.canDeactivate ? component.canDeactivate() : true
  }
}
